<template>
  <v-toolbar-title class="text-uppercase white--text">
    <img src="../../assets/images/qumulex_logo_white.svg" height="20">
  </v-toolbar-title>
</template>

<script>
export default {
  name: "Title"
}
</script>